<app-hero-section [creative]="true"></app-hero-section>

<app-style-section variant="creative"></app-style-section>

<app-inspire-section></app-inspire-section>

<app-banner-section></app-banner-section>

<app-process-section></app-process-section>

<app-promo-section></app-promo-section>

<app-products-section></app-products-section>

<app-testimonials-section></app-testimonials-section>

<app-faq-section></app-faq-section>

<app-create-section></app-create-section>
